import React, { useMemo, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"; // Import useNavigate and Link


import Tabs from "../../Common/misc/Tabs";
import DestinationDetails from "./Components/DestinationDetails";

import { toast } from 'react-toastify';

import { useSelector, useDispatch } from 'react-redux'; // Import useSelector and useDispatch
import { fetchIntegrationById, saveIntegrationAsync } from '../../Redux/slices/integrationSlice'; // Import the async thunk
import tabsList from "@Common/data/editor-tabs.json";

const AddIntegrationDestination = () => {

  const dispatch = useDispatch();
  const integrationDetails = useSelector((state) => state.integration.selectedIntegration);
  const status = useSelector((state) => state.integration.status);
  const error = useSelector((state) => state.integration.error);

  const { id } = useParams();


  useEffect(() => {
    dispatch(fetchIntegrationById(id));
  }, [dispatch, id]);

  const navigate = useNavigate(); // Get the navigate function

  const handleGoToDashboard = () => {
    navigate("/integrations/listing");

  };

  const onTabSelected = (pageName) => {
    navigate(`/integrations/${id}/${pageName.toLowerCase()}`);
  }


  const handleGoBack = () => {
    // router.back();
    navigate(`/integrations/${id}/source`);
  };

  const handleGotoHome = () => {
    navigate("/");
  }


  const handleGotoInvocations = () => {
    navigate(`/integrations/${id}/invocations`);
  };

  const handleGoNext = () => {
    //router.push("/add-integration/source-details"); // Navigates to the /about page
    navigate(`/integrations/${id}/data-mapping`); // Navigate to the next page
  };

  const handleSave = async () => {
    // if (!integrationDetails || !integrationDetails.name || !integrationDetails.description) {
    //   toast.error("Please fill in both the Name and Description fields.");
    //   return;
    // }
    try {
      const resultAction = await dispatch(saveIntegrationAsync({ id, integrationDetails, status: 'Draft' }));
      if (resultAction && resultAction.payload.message) {
        if (resultAction.payload.status === "success" && resultAction.payload.message === "Record upserted successfully") {
          toast.success('Integration saved successfully!');
        } else {
          toast.error(resultAction.payload.message);
        }
      } else if (saveIntegrationAsync.fulfilled.match(resultAction)) {
        toast.success('Integration saved successfully!');
      } else {
        toast.error('Failed to save integration.');
      }
    } catch (err) {
      console.log(err);
      toast.error('An error occurred while saving.');
    } finally {
      // setIsLoading(false);
    }
  }

  return (
    <div className="mx-auto mt-20 px-12">
      <section className="">
        <div className="sm:flex sm:items-center sm:justify-between">
          <div>
            <div className="flex items-center gap-x-3">
              

              <button
                onClick={handleGoToDashboard}
                title="Dashboard"
                className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-gray-200 px-2 py-2 text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
              >
                <svg className="h-5 w-6" viewBox="0 -4.5 31 31" version="1.1" fill="#000000">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round"
                    strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier">
                    <desc>Created with Sketch Beta.</desc> <defs> </defs>
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Icon-Set-Filled"
                        transform="translate(-206.000000, -626.000000)" fill="#000000">
                        <path d="M235,643 L216,643 C214.896,643 214,643.896 214,645 C214,646.104 214.896,647 216,647 L235,647 C236.104,647 237,646.104 237,645 C237,643.896 236.104,643 235,643 L235,643 Z M235,635 L216,635 C214.896,635 214,635.896 214,637 C214,638.104 214.896,639 216,639 L235,639 C236.104,639 237,638.104 237,637 C237,635.896 236.104,635 235,635 L235,635 Z M216,631 L235,631 C236.104,631 237,630.104 237,629 C237,627.896 236.104,627 235,627 L216,627 C214.896,627 214,627.896 214,629 C214,630.104 214.896,631 216,631 L216,631 Z M209,642 C207.343,642 206,643.343 206,645 C206,646.657 207.343,648 209,648 C210.657,648 212,646.657 212,645 C212,643.343 210.657,642 209,642 L209,642 Z M209,634 C207.343,634 206,635.343 206,637 C206,638.657 207.343,640 209,640 C210.657,640 212,638.657 212,637 C212,635.343 210.657,634 209,634 L209,634 Z M209,626 C207.343,626 206,627.343 206,629 C206,630.657 207.343,632 209,632 C210.657,632 212,630.657 212,629 C212,627.343 210.657,626 209,626 L209,626 Z" id="list" > </path> </g> </g> </g></svg>
              </button>

              <button
                onClick={handleGotoInvocations}
                title="Invocations"
                className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-gray-200 px-2 py-2 text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
              >
                <svg className="h-5 w-6" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Edit / List_Checklist"> <path id="Vector" d="M11 17H20M8 15L5.5 18L4 17M11 12H20M8 10L5.5 13L4 12M11 7H20M8 5L5.5 8L4 7" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g> </g></svg>
              </button>

              <h2 className="dark:text-white w-80 text-lg font-medium text-white">
                {status === 'loading' ? (
                  <div className="my-1 animate-pulse">
                    <div className="h-8 w-80 rounded-full bg-gray-200 dark:bg-gray-700">
                    </div>
                  </div>
                ) : (
                  integrationDetails && integrationDetails.name && integrationDetails.name
                )}
              </h2>

              <div className="rounded-full px-3 py-0 text-xs">
                <Tabs tabsList={tabsList} selectedIndex={2} interactive={true} onTabSelected={onTabSelected} />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-end gap-x-2"> {/* Add this div for buttons */}
            <button
              onClick={handleGoBack}
              className="bg-white flex w-1/2 items-center justify-center gap-x-2 rounded-lg px-2 py-2 text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
            >
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    d="M7.68473 7.33186C8.07526 6.94134 8.07526 6.30817 7.68473 5.91765C7.29421 5.52712 6.66105 5.52712 6.27052 5.91765L1.60492 10.5832C0.823873 11.3643 0.823872 12.6306 1.60492 13.4117L6.27336 18.0801C6.66388 18.4706 7.29705 18.4706 7.68757 18.0801C8.0781 17.6896 8.0781 17.0564 7.68757 16.6659L4.02154 12.9998L22 12.9998C22.5523 12.9998 23 12.5521 23 11.9998C23 11.4476 22.5523 10.9998 22 10.9998L4.01675 10.9998L7.68473 7.33186Z"
                    fill="#0F0F0F"
                  ></path>{" "}
                </g>
              </svg>
              Prev
            </button>
            <button
              onClick={handleSave}
              className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-gray-200 px-2 py-2.5 text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
            >
              Save
            </button>
            <button
              onClick={handleGoNext}
              className="bg-white flex w-1/2 items-center justify-center gap-x-2 rounded-lg px-2 py-2 text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
            >
              Next
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    d="M16.3153 16.6681C15.9247 17.0587 15.9247 17.6918 16.3153 18.0824C16.7058 18.4729 17.339 18.4729 17.7295 18.0824L22.3951 13.4168C23.1761 12.6357 23.1761 11.3694 22.3951 10.5883L17.7266 5.9199C17.3361 5.52938 16.703 5.52938 16.3124 5.91991C15.9219 6.31043 15.9219 6.9436 16.3124 7.33412L19.9785 11.0002L2 11.0002C1.44772 11.0002 1 11.4479 1 12.0002C1 12.5524 1.44772 13.0002 2 13.0002L19.9832 13.0002L16.3153 16.6681Z"
                    fill="#0F0F0F"
                  ></path>{" "}
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div className="mt-4">
          <DestinationDetails details={integrationDetails} isLoading={status === 'loading'} error={error} />
        </div>
      </section>
    </div>
  )
}

export default AddIntegrationDestination;